/**
 * Konfigurator Mobile App Mode
 * Transforms the zaun-konfigurator into a step-by-step
 * native app-like experience on mobile (≤ 989px).
 * Desktop remains completely unchanged.
 *
 * Strategy: Instead of moving form elements out of the form
 * (which would break submission), we insert step panels INSIDE
 * the form and move the .konfig-option elements into them.
 * This keeps all inputs within the form.
 */
(function () {
  'use strict';

  /* ---- Bail on desktop ---- */
  if (window.innerWidth > 989) return;

  var konfig = document.querySelector('.konfig');
  if (!konfig) return;

  /* ---- Settings from data attributes (set by Liquid) ---- */
  var wrapper = document.getElementById('KonfigMobileApp');
  if (!wrapper) return;

  var enableStepFlow = wrapper.dataset.stepFlow === 'true';
  var showPriceBar = wrapper.dataset.showPriceBar === 'true';
  var btnNext = wrapper.dataset.btnNext || 'Weiter';
  var btnBack = wrapper.dataset.btnBack || 'Zurück';
  var btnCart = wrapper.dataset.btnCart || 'In den Warenkorb';

  if (!enableStepFlow) return;

  /* ---- Enable step mode ---- */
  document.body.classList.add('konfig-step-mode');

  /* ---- Define steps ---- */
  var steps = [
    { id: 'step-masse', title: 'Zaun-Maße', icon: 'straighten', label: 'Maße' },
    { id: 'step-farbe', title: 'Farbe & Finish', icon: 'palette', label: 'Farbe' },
    { id: 'step-pfosten', title: 'Pfosten-System', icon: 'construction', label: 'Pfosten' },
    { id: 'step-summary', title: 'Zusammenfassung', icon: 'checklist', label: 'Übersicht' }
  ];

  var currentStep = 0;

  /* ---- Build step indicator ---- */
  var stepsNav = document.createElement('div');
  stepsNav.className = 'konfig-mobile-steps';

  steps.forEach(function (step, idx) {
    if (idx > 0) {
      var line = document.createElement('div');
      line.className = 'konfig-mobile-step__line';
      line.dataset.lineIndex = idx - 1;
      stepsNav.appendChild(line);
    }

    var stepEl = document.createElement('div');
    stepEl.className = 'konfig-mobile-step';
    stepEl.dataset.stepIndex = idx;
    stepEl.innerHTML =
      '<span class="konfig-mobile-step__number">' + (idx + 1) + '</span>' +
      '<span class="konfig-mobile-step__label">' + step.label + '</span>';
    stepEl.addEventListener('click', function () { goToStep(idx); });
    stepsNav.appendChild(stepEl);
  });

  /* ---- References ---- */
  var form = document.getElementById('konfig-product-form');
  var konfTable = konfig.querySelector('.konfig-table');
  var summaryEl = konfig.querySelector('.konfig-summary');
  var trustEl = konfig.querySelector('.konfig-trust');

  if (!form || !konfTable) return;

  /* ---- Insert step nav before the form (inside konfig-info) ---- */
  form.parentNode.insertBefore(stepsNav, form);

  /* ---- Identify option elements by their labels ---- */
  var allSelects = konfTable.querySelectorAll('.konfig-select[data-option-index]');
  var zaunlaengeInput = document.getElementById('konfig-zaunlaenge');
  var pfostenInput = document.getElementById('konfig-pfosten-count');
  var eckpfostenInput = document.getElementById('konfig-eckpfosten-count');

  /* ---- Classify selects by label text ---- */
  var hoeheOption = null;
  var staerkeOption = null;
  var farbeOption = null;
  var otherOptions = [];

  allSelects.forEach(function (sel) {
    var option = sel.closest('.konfig-option');
    if (!option) return;
    var label = option.querySelector('.konfig-option__label');
    if (!label) return;
    var text = label.textContent.toLowerCase();

    if (text.indexOf('höhe') !== -1 || text.indexOf('hohe') !== -1 || text.indexOf('zaunhöhe') !== -1) {
      hoeheOption = option;
    } else if (text.indexOf('stärke') !== -1 || text.indexOf('starke') !== -1) {
      staerkeOption = option;
    } else if (text.indexOf('farbe') !== -1) {
      farbeOption = option;
    } else {
      otherOptions.push(option);
    }
  });

  /* Find Zaunlänge option */
  var zaunlaengeOption = zaunlaengeInput ? zaunlaengeInput.closest('.konfig-option') : null;

  /* Find Pfosten / Eckpfosten options */
  var pfostenOption = pfostenInput ? pfostenInput.closest('.konfig-option') : null;
  var eckpfostenOption = eckpfostenInput ? eckpfostenInput.closest('.konfig-option') : null;

  /* Find radio group options (Pfostenkappen & Montageart) */
  var pfostenkappen = document.querySelector('[data-radio-name="properties[Pfostenkappen]"]');
  var montageartEl = document.querySelector('[data-radio-name="properties[Montageart]"]');
  var kappenOption = pfostenkappen ? pfostenkappen.closest('.konfig-option') : null;
  var montageOption = montageartEl ? montageartEl.closest('.konfig-option') : null;

  /* ---- Create step panels INSIDE the form ---- */
  var panelsContainer = document.createElement('div');
  panelsContainer.className = 'konfig-step-panels';

  /* Step 1: Zaun-Maße (Höhe + Stärke + Zaunlänge) */
  var panel1 = document.createElement('div');
  panel1.className = 'konfig-step-panel';
  panel1.id = 'konfig-step-masse';
  panel1.innerHTML = '<h3 class="konfig-step-panel__title"><span class="material-symbols-outlined">straighten</span> Zaun-Maße festlegen</h3>';
  var step1Card = document.createElement('div');
  step1Card.className = 'konfig-step-card';
  if (hoeheOption) step1Card.appendChild(hoeheOption);
  if (staerkeOption) step1Card.appendChild(staerkeOption);
  if (zaunlaengeOption) step1Card.appendChild(zaunlaengeOption);
  panel1.appendChild(step1Card);
  panelsContainer.appendChild(panel1);

  /* Step 2: Farbe & Finish */
  var panel2 = document.createElement('div');
  panel2.className = 'konfig-step-panel';
  panel2.id = 'konfig-step-farbe';
  panel2.innerHTML = '<h3 class="konfig-step-panel__title"><span class="material-symbols-outlined">palette</span> Farbe & Finish wählen</h3>';
  var step2Card = document.createElement('div');
  step2Card.className = 'konfig-step-card';
  if (farbeOption) step2Card.appendChild(farbeOption);
  otherOptions.forEach(function (opt) { step2Card.appendChild(opt); });
  panel2.appendChild(step2Card);
  panelsContainer.appendChild(panel2);

  /* Step 3: Pfosten-System */
  var panel3 = document.createElement('div');
  panel3.className = 'konfig-step-panel';
  panel3.id = 'konfig-step-pfosten';
  panel3.innerHTML = '<h3 class="konfig-step-panel__title"><span class="material-symbols-outlined">construction</span> Pfosten-System konfigurieren</h3>';
  var step3Card = document.createElement('div');
  step3Card.className = 'konfig-step-card';
  if (pfostenOption) step3Card.appendChild(pfostenOption);
  if (eckpfostenOption) step3Card.appendChild(eckpfostenOption);
  if (kappenOption) step3Card.appendChild(kappenOption);
  if (montageOption) step3Card.appendChild(montageOption);
  panel3.appendChild(step3Card);
  panelsContainer.appendChild(panel3);

  /* Step 4: Zusammenfassung */
  var panel4 = document.createElement('div');
  panel4.className = 'konfig-step-panel';
  panel4.id = 'konfig-step-summary';
  panel4.innerHTML = '<h3 class="konfig-step-panel__title"><span class="material-symbols-outlined">checklist</span> Ihre Konfiguration</h3>';
  if (summaryEl) panel4.appendChild(summaryEl);
  if (trustEl) panel4.appendChild(trustEl);
  panelsContainer.appendChild(panel4);

  /* Insert panels inside the form, before the table */
  form.insertBefore(panelsContainer, konfTable);

  /* Hide the original (now mostly empty) table */
  konfTable.style.display = 'none';

  /* ---- Build bottom action bar ---- */
  var bottomBar = document.createElement('div');
  bottomBar.className = 'konfig-mobile-bottom-bar';
  bottomBar.id = 'KonfigMobileBottomBar';

  var priceRowHtml = '';
  if (showPriceBar) {
    priceRowHtml =
      '<div class="konfig-mobile-bottom-bar__price-row">' +
        '<div>' +
          '<div class="konfig-mobile-bottom-bar__price-label">Gesamtpreis</div>' +
          '<div class="konfig-mobile-bottom-bar__price" id="konfig-mobile-price">€0,00</div>' +
        '</div>' +
        '<div class="konfig-mobile-bottom-bar__step-info" id="konfig-mobile-step-info">Schritt 1 von 4</div>' +
      '</div>';
  } else {
    priceRowHtml =
      '<div class="konfig-mobile-bottom-bar__price-row">' +
        '<div class="konfig-mobile-bottom-bar__step-info" id="konfig-mobile-step-info" style="width:100%;text-align:center;">Schritt 1 von 4</div>' +
      '</div>';
  }

  bottomBar.innerHTML = priceRowHtml +
    '<div class="konfig-mobile-bottom-bar__buttons" id="konfig-mobile-buttons"></div>';

  document.body.appendChild(bottomBar);

  var mobilePrice = document.getElementById('konfig-mobile-price');
  var mobileStepInfo = document.getElementById('konfig-mobile-step-info');
  var mobileButtons = document.getElementById('konfig-mobile-buttons');

  /* ---- Price sync ---- */
  function syncPrice() {
    if (!showPriceBar || !mobilePrice) return;
    var totalEl = document.getElementById('konfig-total');
    if (totalEl) {
      mobilePrice.textContent = totalEl.textContent;
    }
  }

  /* Observe price changes via MutationObserver */
  var totalEl = document.getElementById('konfig-total');
  if (totalEl && window.MutationObserver && showPriceBar) {
    var observer = new MutationObserver(syncPrice);
    observer.observe(totalEl, { childList: true, characterData: true, subtree: true });
  }

  /* Also sync on input/select/radio changes */
  ['konfig-zaunlaenge', 'konfig-pfosten-count', 'konfig-eckpfosten-count'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', function () { setTimeout(syncPrice, 50); });
      el.addEventListener('change', function () { setTimeout(syncPrice, 50); });
    }
  });

  document.querySelectorAll('.konfig-select[data-option-index]').forEach(function (sel) {
    sel.addEventListener('change', function () { setTimeout(syncPrice, 50); });
  });

  document.querySelectorAll('.konfig-radio-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { setTimeout(syncPrice, 50); });
  });

  /* ---- Step navigation ---- */
  function goToStep(idx) {
    if (idx < 0 || idx >= steps.length) return;
    currentStep = idx;

    /* Update step indicator */
    var stepEls = stepsNav.querySelectorAll('.konfig-mobile-step');
    var lineEls = stepsNav.querySelectorAll('.konfig-mobile-step__line');

    stepEls.forEach(function (el, i) {
      el.classList.remove('is-active', 'is-completed');
      if (i === currentStep) el.classList.add('is-active');
      if (i < currentStep) el.classList.add('is-completed');
    });

    lineEls.forEach(function (el, i) {
      el.classList.remove('is-completed');
      if (i < currentStep) el.classList.add('is-completed');
    });

    /* Update panels */
    var panels = panelsContainer.querySelectorAll('.konfig-step-panel');
    panels.forEach(function (p, i) {
      p.classList.remove('is-active');
      if (i === currentStep) p.classList.add('is-active');
    });

    /* Update step info */
    if (mobileStepInfo) {
      mobileStepInfo.textContent = 'Schritt ' + (currentStep + 1) + ' von ' + steps.length;
    }

    /* Update buttons */
    updateButtons();

    /* Sync price */
    syncPrice();

    /* Scroll to top of steps */
    var stepsTop = stepsNav.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: stepsTop, behavior: 'smooth' });
  }

  function updateButtons() {
    var html = '';

    if (currentStep > 0) {
      html += '<button type="button" class="konfig-mobile-btn konfig-mobile-btn--back" id="konfig-btn-back">' +
        '<span class="material-symbols-outlined">arrow_back</span> ' + btnBack +
        '</button>';
    }

    if (currentStep < steps.length - 1) {
      html += '<button type="button" class="konfig-mobile-btn konfig-mobile-btn--next" id="konfig-btn-next">' +
        btnNext + ' <span class="material-symbols-outlined">arrow_forward</span>' +
        '</button>';
    } else {
      html += '<button type="button" class="konfig-mobile-btn konfig-mobile-btn--cart" id="konfig-btn-add-cart">' +
        '<span class="material-symbols-outlined">shopping_cart</span> ' + btnCart +
        '</button>';
    }

    mobileButtons.innerHTML = html;

    /* Attach event listeners */
    var backBtn = document.getElementById('konfig-btn-back');
    var nextBtn = document.getElementById('konfig-btn-next');
    var cartBtn = document.getElementById('konfig-btn-add-cart');

    if (backBtn) backBtn.addEventListener('click', function () { goToStep(currentStep - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToStep(currentStep + 1); });
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        /* Trigger the original form submit button */
        var originalBtn = document.getElementById('konfig-add-to-cart');
        if (originalBtn) {
          originalBtn.click();
        } else {
          form.submit();
        }
      });
    }
  }

  /* ---- Initialize ---- */
  goToStep(0);
  syncPrice();

  /* Delayed price sync for initial calculation */
  setTimeout(syncPrice, 500);
  setTimeout(syncPrice, 1500);

})();
